import { render, staticRenderFns } from "./MessageFormDevices.vue?vue&type=template&id=0969a17e&scoped=true&"
import script from "./MessageFormDevices.vue?vue&type=script&lang=js&"
export * from "./MessageFormDevices.vue?vue&type=script&lang=js&"
import style0 from "./MessageFormDevices.vue?vue&type=style&index=0&id=0969a17e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0969a17e",
  null
  
)

export default component.exports
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QItem,QItemSection,QItemLabel,QToggle});
